module.exports = __webpack_public_path__ + "img/US.7c1a5293.png";